import { createAsyncThunk } from '@reduxjs/toolkit';
import APIs from '../../apiUrl';

export const getAllReviews = createAsyncThunk(
  'reviews/getAllReviews',
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await APIs.get(`/get_all_review/${page}/${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching reviews:', error);
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch reviews'
      );
    }
  }
);
